import { InstantMessageChannelUserActiveState } from "../enums";

export interface IInstantMessageChannelAddedUser {
    id: string;
    userId: string;
    activeState: InstantMessageChannelUserActiveState;
}

export class InstantMessageChannelAddedUser implements IInstantMessageChannelAddedUser {
    id: string;
    userId: string;
    activeState: InstantMessageChannelUserActiveState;

    constructor();
    constructor(obj: IInstantMessageChannelAddedUser);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.userId = obj && obj.userId || "";
        this.activeState = obj && obj.activeState || InstantMessageChannelUserActiveState.Rejected;
    }

    static createInstantMessageChannelAddedUser(id: string, userId: string, activeState: InstantMessageChannelUserActiveState): InstantMessageChannelAddedUser {
        const result = new InstantMessageChannelAddedUser();
        result.id = id;
        result.userId = userId;
        result.activeState = activeState;
        return result;
    }
}